import { useEffect, useState } from 'react';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useNatureCharges = (projectId?: number | null, activityId?: number | null) => {
  const httpClient = useHttpClient();
  const [natureCharges, setNatureCharges] = useState<any[]>([]);

  useEffect(() => {
    const fetchNatureCharges = async () => {
      try {
        const url = projectId
          ? `/api/project/${projectId}/nature-charges${activityId ? `?activityId=${activityId}` : ''}`
          : `/api/naturecharge/all`;
        const response = await httpClient.current?.get(url);
        if (response?.data) {
          setNatureCharges(response.data);
        }
      } catch (err) {
        console.error('Erreur API NatureCharge:', err);
      }
    };
    fetchNatureCharges();
  }, [httpClient, projectId, activityId]);

  return { natureCharges };
};
